<template>
	<div class="street-parking-view">
		<BaseAccordionCard :accordion_header="getStateWithParam('parking_rates_label')">
			<template v-slot:component>
				<ParkingInfo class="accordion-card-middle" />
			</template>
		</BaseAccordionCard>
		<BaseAccordionController
			:accordion_header="getStateWithParam('label_parking')"
			:expand_accondion="true"
		>
			<template v-slot:component>
				<div class="filter-indicator">
					<v-btn
						v-if="filteredcategory"
						@click="clearFilter"
						class="grey--text text--darken-4"
						small
					>
						<div class="text-dark text-truncate mr-2">
							<img :src="currentcategory.icon" alt="currentcategory.name1" height="16" style="float:left" class="mr-1">
							<span class="pt-1">{{currentcategory.name1}}</span>
						</div>
						<v-icon small>close</v-icon>
					</v-btn>
				</div>
				<MapController
					:enableoptions="true"
					:optionsbottom="true"
					:hideoptions='hideoptions'
					:fitbounds="fitbounds"
				>
					<template v-for=" (feature, featureind) in featureslist ">
						<l-marker
							v-if="feature.geometry.type == 'Point'"
							:key="'marker-' + featureind"
							:lat-lng="map_helper.getMarkerCoordinatesSwitch(feature.geometry.coordinates)"
							:icon="map_helper.getIcon(feature.properties.kategoria.icon)"
						>
							<l-popup>
								<template
									v-if="feature.properties.kategoria.id == '1A' || feature.properties.kategoria.id == '1B' || feature.properties.kategoria.id == '1C'">
									<div class="item item-divider" @click="popupAction(feature, {})">
										<span :style="{ 'color': feature.properties.kategoria.color }">
											{{feature.properties.kategoria.name1}}
										</span>
										<div>{{feature.properties.name}}</div>
									</div>
									<div class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingzone')}}:</span>
										<span class="line-value font-weight-bold">{{feature.properties.zone_code}}</span>
									</div>
									<div v-if="feature.properties.zona" class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingprice')}}: </span>
										<span class="line-value font-weight-bold">{{feature.properties.zona.cmimi}} Leke</span>
									</div>
									<div v-if="feature.properties.zona" class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parking_timeframe')}}: </span>
										<span class="line-value font-weight-bold">{{feature.properties.zona.orari}}</span>
									</div>
									<div v-if="feature.properties.white_seats || showemptyfields" class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingfree')}}: </span>
										<span class="line-value font-weight-bold">
											<span v-if="feature.properties.white_seats">{{feature.properties.white_seats}}</span>
											<span v-else>-</span>
										</span>
									</div>
									<div v-if="feature.properties.disabled_seats || showemptyfields" class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingdisabled')}}: </span>
										<span v-if="feature.properties.disabled_seats">{{feature.properties.disabled_seats}}</span>
										<span v-else>-</span>
									</div>
									<div v-if="feature.properties.blue_seats || showemptyfields" class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingpaid')}}: </span>
										<span v-if="feature.properties.blue_seats">{{feature.properties.blue_seats}}</span>
										<span v-else>-</span>
									</div>
									<div v-if="feature.properties.taxi_seats || showemptyfields" class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingtaxi')}}: </span>
										<span v-if="feature.properties.taxi_seats">{{feature.properties.taxi_seats}}</span>
										<span v-else>-</span>
									</div>
								</template>
								<template v-else-if="feature.properties.kategoria.id != 4">
									<div class="item item-divider" @click="popupAction(feature, {})">
										<span :style="{ 'color': feature.properties.kategoria.color }">
											{{feature.properties.kategoria.name1}}
										</span>
										<div>{{feature.properties.data.rruga_emertimi}}</div>
									</div>
									<div class="popup-line item item-icon-right">
										<span class="line-name mr-2">{{getStateWithParam('parkingseats')}}: </span>
										<span class="line-value font-weight-bold">{{feature.properties.data.capacity}}</span>
									</div>
								</template>
								<div
									v-if="feature.properties.kategoria.id != 1"
									class="popup-line item item-icon-right"
									@click="filteredcategory = feature.properties.kategoria.id"
								>
									<span class="line-name">{{getStateWithParam('viewall')}}</span>
									<v-icon class="line-icon">chevron_right</v-icon>
								</div>
							</l-popup>
						</l-marker>
						<l-geo-json
							v-else
							:key="'shape-' + featureind"
							:geojson="feature"
							:options-style="styleFunction(featureind)"
						></l-geo-json>
					</template>
					<template v-slot:options>
						<v-list>
							<template v-for="kategori in data_map_no_street.kategorite">
								<v-list-tile
									:key="'kategori-' + kategori.id"
									@click="filteredcategory = kategori.id"
								>
									<v-list-tile-avatar>
										<v-avatar size="32px" kategori>
											<img
												:src="kategori.icon"
											>
										</v-avatar>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title>
											<span v-if="type_language == 1">{{ kategori.name1 }}</span>
											<span v-else>{{ kategori.name2 }}</span>
										</v-list-tile-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-switch v-model="filteredcategory" :value="kategori.id"></v-switch>
									</v-list-tile-action>
								</v-list-tile>
								<v-divider inset :key="'kategoridivider-' + kategori.id"></v-divider>
							</template>
						</v-list>
					</template>
				</MapController>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import ParkingInfo from "@/components/cards/ParkingInfoCard.vue";
import MapController from "@/components/cards/MapController.vue";
import { LGeoJson, LMarker, LPopup } from "vue2-leaflet";
import parking from "@/config/api/api_events/parking.js";
import map_helper from "@/config/js_helper/map_helper.js";
import { mapState } from 'vuex'

export default {
	name: "StreetMap",
	props: {},
	components: {
		ParkingInfo,
		//MapCard
		MapController,
		LGeoJson,
		LMarker,
		LPopup,
	},
	data() {
		return {
			map_helper: map_helper,
			data_map_street: [],
			data_map_street_to_pay: {},
			data_map_no_street: [],
			from_where: 1,
			icon_url: require("@/assets/img/new_icons/parking.svg"),
			filteredcategory: null,
			hideoptions: false,
			fitbounds: 0,
			showemptyfields: false
		};
	},
	computed: {
		...mapState(['type_language']),
		featureslist(){
			let list = []
			if (this.data_map_no_street.geodata && this.data_map_no_street.geodata.features) {
				if (this.filteredcategory) {
					list = this.data_map_no_street.geodata.features.filter( (feature) => feature.properties.kategoria.id == this.filteredcategory )
				} else {
					list = this.data_map_no_street.geodata.features
				}
			}
			return list
		},
		currentcategory(){
			let categorykey = 'kategori_' + this.filteredcategory
			return this.data_map_no_street.kategorite[categorykey]
		}
	},
	watch: {
		filteredcategory(){
			this.hideoptions = !this.hideoptions
		},
		featureslist(){
			this.fitbounds ++
		}
	},
	created() {
		this.getParkingNoStreetsFromCall();
	},
  	methods: {
		clearFilter(){
			this.filteredcategory = null
		},
		getParkingNoStreetsFromCall() {
			parking
			.getParkingNoStreet()
			.then(response => {
				//this.data_map_no_street = response;
				this.data_map_no_street = this.enrichNoStreetsParking(response);
			})
			.then(() => {
				// Todo Change This
				this.$store.state.active_loader = false;
				this.getParkingStreetsFromCall();
			})
			.catch(err => {
				this.$store.state.active_loader = false;
				console.log(err);
			});
		},
		getParkingStreetsFromCall() {
			parking
			.getParkingStreets()
			.then(response => {
				this.data_map_street = response;
				this.showemptyfields = response.showemptyfields
			})
			.then(() => {
				this.prepareDataToSend();
			})
			.catch(err => {
				console.log(err);
			});
		},
		prepareDataToSend() {
			this.setCategoryandMarkerForStreetParking()
			this.data_map_no_street.geodata.features = _.union(
				this.data_map_no_street.geodata.features,
				this.data_map_street.rruget
				//this.setCategoryandMarkerForStreetParking(this.data_map_street).features
			);
			//this.data_map_no_street.note_data_to_pay = this.data_map_street_to_pay;
		},
		setCategoryandMarkerForStreetParking(data){
			let kategoria = this.data_map_no_street.kategorite['kategori_1']
			let zones = {}
			for (const zone in this.data_map_street.zonat) {
				zones[this.data_map_street.zonat[zone].zona_kodi] = this.data_map_street.zonat[zone]
				zones[this.data_map_street.zonat[zone].zona_kodi].orari = this.data_map_street.parkim_orari_me_pagese
			}
			for (const cmim in this.data_map_street.cmimet) {
				zones[this.data_map_street.zonat[cmim].zona_kodi].cmimi = this.data_map_street.cmimet[cmim].cmimi
			}
			_.each(this.data_map_street.rruget, (rruga, i) => {
				rruga.properties.kategoria = this.data_map_no_street.kategorite[rruga.properties.kategori_code];
				rruga.properties.zona = zones[rruga.properties.zone_code]
			});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		enrichNoStreetsParking(response){
			response.geodata.features.forEach((feature) => {
				let letkategoriakey = 'kategori_' + feature.properties.kategoria
				feature.properties.kategoria = response.kategorite[letkategoriakey]
				let metadatakey = 'meta_' + feature.properties.metaid
				let data = response.metadata[metadatakey]
				if (data) {
					feature.properties.data = data
					feature.properties.data.rruga_emertimi = data.rruga
				} else {
					feature.properties.data = {}
				}
			})
			return response
		},
		styleFunction(index) {
			let styles = map_helper.getLineStrokeStyle(
				this.data_map_no_street.geodata.features,
				this.from_where,
				index
			);
			return styles
		},
		getIconForMarker(categoryid){
			let key = 'kategori_' + categoryid
			//let defaulticon = this.data_map_no_street.kategorite['kategori_1'] ? this.data_map_no_street.kategorite['kategori_1'].icon : this.icon_url
			let iconpath = this.data_map_no_street.kategorite[key] ? this.data_map_no_street.kategorite[key].icon : this.icon_url
			return  map_helper.getIcon(iconpath)
		},
		popupAction(feature){
			console.log(feature)
		}
  	},
};
</script>


<style scope lang="scss" src="./StreetMap.scss">
</style>


